import { useState, useCallback } from 'react';
import { useAuth } from '../../components/auth/AuthModule';
import { toast } from 'react-toastify';
import { user as userApi } from '../../utils/api';
import { useTranslation } from 'react-i18next';

export const useDashboardControllers = () => {
  const { user, setUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();

  const updateProfile = useCallback(async (updateData) => {
    setLoading(true);
    try {
      console.log('Updating profile with data:', {
        ...updateData,
        password: updateData.password ? '[REDACTED]' : undefined
      });
      
      const response = await userApi.updateProfile(updateData);
      console.log('Profile update response:', {
        user: {
          ...response.user,
          _id: response.user._id,
          username: response.user.username,
          imageUrl: response.user.imageUrl || 'not set'
        }
      });
      
      // Update user context with new data
      setUser(response.user);
      
      // Update language if it was changed
      if (updateData.language && updateData.language !== i18n.language) {
        await i18n.changeLanguage(updateData.language);
      }

      toast.success('Profile updated successfully');
      return { success: true, user: response.user };
    } catch (error) {
      console.error('Error updating profile:', error);
      const errorMessage = error.response?.data?.message || 'Error updating profile';
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  }, [setUser, i18n]);

  return {
    user,
    loading,
    updateProfile
  };
};

export default useDashboardControllers; 